import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const SearchAndSort = ({ searchQuery, onSearchChange, sortBy, onSortChange, filterActive, onFilterChange }) => {
  const sortOptions = [
    { value: 'dateAdded', label: 'Date Added (Newest)' },
    { value: 'dateAddedOld', label: 'Date Added (Oldest)' },
    { value: 'address', label: 'Address (A-Z)' },
    { value: 'addressDesc', label: 'Address (Z-A)' },
    { value: 'offerCount', label: 'Most Offers' },
    { value: 'offerCountLow', label: 'Least Offers' },
  ];

  const filterOptions = [
    { value: 'active', label: 'Active Only' },
    { value: 'inactive', label: 'Not Active Only' },
    { value: 'all', label: 'All Properties' },
  ];

  return (
    <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-6 md:mb-8">
      <div className="flex-1">
        <div className="relative">
          <Icon 
            name="Search" 
            size={18} 
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground md:w-5 md:h-5" 
          />
          <Input
            type="search"
            placeholder="Search by address or owner name..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="pl-10 md:pl-11"
          />
        </div>
      </div>
      <div className="sm:w-48">
        <Select
          options={filterOptions}
          value={filterActive}
          onChange={onFilterChange}
          placeholder="Filter..."
        />
      </div>
      <div className="sm:w-64">
        <Select
          options={sortOptions}
          value={sortBy}
          onChange={onSortChange}
          placeholder="Sort by..."
        />
      </div>
    </div>
  );
};

export default SearchAndSort;